// Исключения для ссылок на доменные модели из общих UI, например журнала событий.
// Если у модели нет стандартного `{Model}Details` route, здесь задается явный маршрут.
export const MODEL_ROUTE_OVERRIDES = {
  "Communication::Post": (id) => ({ name: "CommunicationPostDetails", params: { id } }),
  "Catalog::Item": (id) => ({
    name: "CatalogItems",
    query: { catalog_item_id: id },
  }),
  CompanyUser: "UserDetails",
  Conversation: (id) => ({
    name: "Chats",
    query: { conversation_id: id },
  }),
  "Edo::Document": "EdoDocumentDetails",
  Expense: (id) => ({
    name: "Expenses",
    query: { expense_id: id },
  }),
  "Fleet::Repair": (id) => ({
    name: "Repairs",
    query: { repair_id: id },
  }),
  "Fleet::Vehicle::Remark": (id, routeParams = {}) => {
    if (!routeParams.vehicle_id) return null;

    return {
      name: "VehicleDetails",
      params: { id: routeParams.vehicle_id },
      query: {
        tab: "remarks",
        id,
      },
    };
  },
  Message: (id, routeParams = {}) => {
    if (!routeParams.conversation_id) return null;

    return {
      name: "Chats",
      query: {
        conversation_id: routeParams.conversation_id,
        message_id: id,
      },
    };
  },
};
